import { render, staticRenderFns } from "./ReviewIssuesPullout.vue?vue&type=template&id=3c712cdc&scoped=true&"
import script from "./ReviewIssuesPullout.vue?vue&type=script&lang=js&"
export * from "./ReviewIssuesPullout.vue?vue&type=script&lang=js&"
import style0 from "./ReviewIssuesPullout.vue?vue&type=style&index=0&id=3c712cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c712cdc",
  null
  
)

export default component.exports